import { createFileRoute } from '@tanstack/react-router';
import { DeviceAuthPage } from '@/components/settings/sdk';

export const Route = createFileRoute('/device-auth')({
  component: DeviceAuthRoutePage,
});

function DeviceAuthRoutePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <DeviceAuthPage />
    </div>
  );
}
